import React, { useEffect, useState } from 'react'
import profileImg from '../../Images/profile.png'
import { IoIosArrowDown } from "react-icons/io";
import { Link, NavLink } from 'react-router-dom';
import { TiThMenu } from "react-icons/ti";
import axios from 'axios';

type AdminProfileProps = {
  menuicon: React.ReactNode;
};

interface UserData {
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: number;
  password: string;
}

const AdminProfile: React.FC<AdminProfileProps> = ({menuicon})=> {
 const api = process.env.REACT_APP_API_URL;
    const [showPopup, setshowPopup] = useState(false);
    const[userdetails, setUserdetails] = useState<UserData>();
    const[adminId, SetAdminId] = useState<number>(Number || null);

  useEffect(() => {
  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${api}/auth/admindashboard`, { withCredentials: true });
      SetAdminId(response.data.id);
      setUserdetails(response.data);
      console.log("Fetched user data:", response.data);
    } catch (error: any) {
      console.error("Fetch failed:", error);
    }
  };

  fetchUserData();
}, [api]);







    return (
        <>
            <div className='w-[100%] flex justify-between p-4 pr-[40px] bg-white '>
                 {menuicon}
                <div className='flex justify-center items-center gap-2 cursor-pointer' onMouseOver={() => { setshowPopup(true) }} onMouseOut={() => { setshowPopup(false) }}><img className='w-[32px]' src={profileImg} alt="" /> <span className='flex justify-center items-center font-[500] text-[14px] text-gray-700 '>admin <IoIosArrowDown /></span></div>
            </div>

            {showPopup &&
                <div className='absolute right-[10px] top-[50px] pt-12 pr-2' onMouseOver={() => { setshowPopup(true) }} onMouseOut={() => { setshowPopup(false) }} >
                    <div className='bg-white rounded-md p-2 w-[150px] flex flex-col gap-4 mt-[-20px] ' >

                        <NavLink to='profile'
                            className={({ isActive }) =>
                                `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                                } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                            }>
                            Profile
                        </NavLink>
                        <NavLink to='passwordchange' className={({ isActive }) =>
                            `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                            } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                        }>
                            Password Change
                        </NavLink>
                        <NavLink to='logout' className={({ isActive }) =>
                            `text-sm font-medium ${isActive ? 'text-[#7a70ba]' : 'text-gray-600'
                            } hover:text-[#7a70ba] text-[14px] font-[500] text-gray-600`
                        }>
                            Logout
                        </NavLink>
                    </div>
                </div>
            }


            



        </>
    )
}

export default AdminProfile
